import { render } from "./RuleLinksCard.vue?vue&type=template&id=755b5474"
import script from "./RuleLinksCard.vue?vue&type=script&lang=js"
export * from "./RuleLinksCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleLinksCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "755b5474"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('755b5474', __exports__)) {
    api.reload('755b5474', __exports__)
  }
  
  module.hot.accept("./RuleLinksCard.vue?vue&type=template&id=755b5474", () => {
    api.rerender('755b5474', render)
  })

}


export default __exports__